import {spotheroDelete} from 'api';
import {sendSentryException} from 'utils/error-handling';
import type {EmployeeGroupId} from 'utils/typeid';

export interface DeleteEmployeeGroupParams {
    employeeGroupId: EmployeeGroupId;
}

const deleteEmployeeGroup = async ({
    employeeGroupId,
}: {
    employeeGroupId: EmployeeGroupId;
}) => {
    try {
        await spotheroDelete(`/employee-groups/${employeeGroupId}/`);
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default deleteEmployeeGroup;
